import React, { useEffect, useState, useRef } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import moment from "moment";
import "./chart.scss";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);
function VatMovementLineChart({ data }) {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState({
    datasets: [],
  });

  useEffect(() => {
    const chart = chartRef.current;

    if (chart) {
      const ctx = chart.ctx;
      const gradient = ctx.createLinearGradient(0, 0, 0, chart.height);
      gradient.addColorStop(0, "rgba(16, 185, 129, 0.5)");
      gradient.addColorStop(1, "rgba(16, 185, 129, 0)");

      setChartData({
        labels:
          data?.map((item) => moment(item.transactionDate).format("YYYY-MM-DD")) ??
          [],
        datasets: [
          {
            label: "VAT Movement",
            data: data?.map((data) => data.totalVatAmount) ?? [],
            borderColor: "#10b981",
            backgroundColor: gradient,
            tension: 0.5,
            pointBackgroundColor: "#ffffff",
            pointBorderColor: "#10b981",
            pointBorderWidth: 2,
            pointRadius: 4,
            pointHoverRadius: 7,
            fill: true,
            borderWidth: 4,
          },
        ],
      });
    }
  }, [data]);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: 'index',
      intersect: false,
    },
    plugins: {
      title: {
        display: true,
        text: "VAT Movement",
        color: "#f3f4f6",
        position: "top",
        font: {
          size: 18,
          family: "'Inter', sans-serif",
          weight: '700',
        },
        padding: {
          top: 10,
          bottom: 30,
        },
        align: "start",
      },
      legend: {
        display: false,
      },
      tooltip: {
        backgroundColor: 'rgba(17, 24, 39, 0.95)',
        titleColor: '#f3f4f6',
        bodyColor: '#d1d5db',
        borderColor: 'rgba(255,255,255,0.1)',
        borderWidth: 1,
        padding: 12,
        cornerRadius: 12,
        displayColors: true,
        boxPadding: 4,
        titleFont: {
          size: 14,
          family: "'Inter', sans-serif",
        },
        bodyFont: {
          size: 13,
          family: "'Inter', sans-serif",
        },
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || '';
            if (label) {
              label += ': ';
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat('en-US').format(context.parsed.y);
            }
            return label;
          }
        }
      }
    },

    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          color: "#9ca3af",
          maxRotation: 45,
          minRotation: 45,
          autoSkip: true,
          maxTicksLimit: 6,
          font: {
            family: "'Inter', sans-serif",
            size: 11
          },
          padding: 5,
        },
        border: {
          display: false
        }
      },
      y: {
        grid: {
          color: 'rgba(255, 255, 255, 0.05)',
          borderDash: [5, 5],
          drawBorder: false,
        },
        ticks: {
          color: "#9ca3af",
          font: {
            family: "'Inter', sans-serif",
            size: 12
          },
          padding: 10,
          callback: function (value) {
            return new Intl.NumberFormat('en-US', {
              notation: "compact",
              compactDisplay: "short",
              maximumFractionDigits: 3
            }).format(value);
          }
        },
        border: {
          display: false
        },
        title: {
          display: false,
        },
      },
    },
  };

  return (
    <>
      <Line ref={chartRef} data={chartData} options={chartOptions} />
    </>
  );
}

export default VatMovementLineChart;
